import {HistoryPlugin} from '@lexical/react/LexicalHistoryPlugin'
import {ListPlugin} from '@lexical/react/LexicalListPlugin'
import {OnChangePlugin} from '@lexical/react/LexicalOnChangePlugin'
import {RichTextPlugin} from '@lexical/react/LexicalRichTextPlugin'
import {LexicalComposer} from '@lexical/react/LexicalComposer'
import {$convertToMarkdownString} from '@lexical/markdown'
import {HeadingNode, QuoteNode} from '@lexical/rich-text'
import {ListItemNode, ListNode} from '@lexical/list'
import {JSX} from 'react'
import {ErrorBoundary} from 'react-error-boundary'
import {EditorState} from 'lexical'
import {MARKDOWN_TRANSFORMERS} from './transformers'
import {ToolbarPlugin} from './ToolbarPlugin'
import {StyledContentEditable, StyledEditorArea, StyledEditorContainer, StyledEditorPlaceholder} from './style'

interface RichTextEditorProps {
    onChange: (value: string) => void
    placeholder?: string
    resetKey?: number
}

const NODES = [HeadingNode, QuoteNode, ListNode, ListItemNode]

const EditorErrorBoundary = ({
    children,
    onError
}: {
    children: JSX.Element
    onError: (error: Error) => void
}): JSX.Element => (
    <ErrorBoundary fallback={null} onError={onError}>
        {children}
    </ErrorBoundary>
)

export const RichTextEditor = ({onChange, placeholder, resetKey}: RichTextEditorProps) => {
    const handleChange = (editorState: EditorState) => {
        editorState.read(() => {
            const markdown = $convertToMarkdownString(MARKDOWN_TRANSFORMERS)
            onChange(markdown)
        })
    }

    return (
        <LexicalComposer
            key={resetKey}
            initialConfig={{
                namespace: 'BugReporterEditor',
                nodes: NODES,
                onError: (error: Error) => console.error(error)
            }}
        >
            <StyledEditorContainer>
                <ToolbarPlugin />
                <StyledEditorArea>
                    <RichTextPlugin
                        contentEditable={<StyledContentEditable spellCheck={false} />}
                        placeholder={<StyledEditorPlaceholder>{placeholder}</StyledEditorPlaceholder>}
                        ErrorBoundary={EditorErrorBoundary}
                    />
                </StyledEditorArea>
            </StyledEditorContainer>
            <HistoryPlugin />
            <ListPlugin />
            <OnChangePlugin onChange={handleChange} />
        </LexicalComposer>
    )
}
